import { Picture } from 'ui-kit/picture'
import ImageMob1x from './image-mob1x.png'
import ImageMob2x from './image-mob2x.png'
import ImageDesk1x from './image-desk1x.png'
import ImageDesk2x from './image-desk2x.png'
import clsx from 'clsx'
import classes from './UniversalIntegrations.module.scss'

export const UniversalIntegrations = ({
  bgIsVisible,
  className,
}: {
  bgIsVisible?: boolean
  className?: string
}) => {
  return (
    <div className={clsx(classes.visual, bgIsVisible && classes.visual__bg)}>
      <div className={clsx(classes.wrapper, className)}>
        <Picture
          className={classes.image}
          mobSrc1x={ImageMob1x.src}
          mobSrc2x={ImageMob2x.src}
          deskSrc1x={ImageDesk1x.src}
          deskSrc2x={ImageDesk2x.src}
          width={350}
          height={888}
          alt='Universal Integrations'
          fetchPriorityHigh
        />
      </div>
    </div>
  )
}
